import React from 'react';
import {
  AboutContainer,
  ContentContainer,
  Content,
  Title,
  Subtitle,
  Text,
  FullWidthSection,
  TwoColGrid,
  LeftCol,
  RightCol,
  AboutImage,
} from './About.styles';
import { useTranslation } from 'react-i18next';

export const About = () => {
  const { t } = useTranslation();
  return (
    <AboutContainer>
      <ContentContainer>
        <Content>
          <FullWidthSection>
            <Title>{t('about.title1')}</Title>
            <Text>{t('about.description1')}</Text>
          </FullWidthSection>

          <TwoColGrid>
            <LeftCol>
              <AboutImage src="/images/o-nas.png" alt="O nas" />
            </LeftCol>
            <RightCol>
              <div>
                <Subtitle>{t('about.subtitle1')}</Subtitle>
                <Text>{t('about.description2')}</Text>
              </div>
              <div>
                <Subtitle>{t('about.subtitle2')}</Subtitle>
                <Text>{t('about.description3')}</Text>
              </div>
            </RightCol>
          </TwoColGrid>
        </Content>
      </ContentContainer>
    </AboutContainer>
  );
};
